import React from 'react';
import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';
import { CHART } from '@/lib/constants';

const SCORE_RANGE = [CHART.SCORE_MIN, CHART.SCORE_MAX];

/**
 * Radar chart for the AWSAI Core 4 domains.
 */
export const DomainRadarChart = React.memo(({ data }) => (
  <div className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm">
    <h3 className="text-xl font-semibold text-slate-900 mb-6">
      AWSAI Core Domains Radar
    </h3>
    <ResponsiveContainer width="100%" height={CHART.RADAR_HEIGHT}>
      <RadarChart data={data}>
        <PolarGrid stroke="#E2E8F0" />
        <PolarAngleAxis dataKey="domain" tick={CHART.TICK_STYLE} />
        <PolarRadiusAxis
          angle={CHART.RADAR_ANGLE}
          domain={SCORE_RANGE}
          tick={CHART.POLAR_RADIUS_STYLE}
        />
        <Radar
          name="Score"
          dataKey="score"
          stroke="#0D9488"
          fill="#0D9488"
          fillOpacity={0.3}
        />
      </RadarChart>
    </ResponsiveContainer>
  </div>
));

/**
 * Bar chart for the Extended Module scores.
 */
export const ExtendedBarChart = React.memo(({ data }) => (
  <div className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm">
    <h3 className="text-xl font-semibold text-slate-900 mb-6">
      Extended Module Scores
    </h3>
    <ResponsiveContainer width="100%" height={CHART.BAR_HEIGHT}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
        <XAxis
          dataKey="domain"
          tick={CHART.BAR_TICK_STYLE}
          angle={CHART.BAR_X_ANGLE}
          textAnchor="end"
          height={CHART.BAR_X_HEIGHT}
        />
        <YAxis domain={SCORE_RANGE} tick={CHART.POLAR_RADIUS_STYLE} />
        <Tooltip />
        <Bar dataKey="score" fill="#0F172A" radius={CHART.BAR_RADIUS} />
      </BarChart>
    </ResponsiveContainer>
  </div>
));

DomainRadarChart.displayName = 'DomainRadarChart';
ExtendedBarChart.displayName = 'ExtendedBarChart';
